module.exports = {"full":{"All-instruments":"All instruments","No-guitar":"No guitar"},"details":{"Lesson-Details":"Lesson Details","Tablature":"Tablature"}};